import { combineReducers } from 'redux';
import pagesReducer from './fetch_pages_reducer';
import pageByIdReducer from './fetch_pagebyid_reducer';
import pageByParentReducer from './fetch_pagebyparent_reducer';
import pageBySlugReducer from './fetch_pagebyslug_reducer';
import postsReducer from './fetch_posts_reducer';
import categoriesReducer from './fetch_categories_reducer';

const rootReducer = combineReducers({
  pagesData: pagesReducer,
  pageData: pageByIdReducer,
  categories: categoriesReducer,
  pageParentData: pageByParentReducer,
  pageSlugData: pageBySlugReducer,
  posts: postsReducer
});

export default rootReducer;



// WEBPACK FOOTER //
// ./src/store/reducers/index.js